<template>
  <div class="archived-bar flex justify-center items-center bg-inline-selection min-h-[24px]">
    <div class="flex items-center text-text-default text-[12px] leading-[1.125rem] gap-x-2">
      {{ message }}
      <span
        v-if="shouldShowRestorationOption"
        class="underline pt"
        @click.stop="restore"
      >
        {{ translate('restoreMakeChange') }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ArchivedBar',

  props: {
    type: {
      type: String,
      required: true,
    },
  },

  emits: ['restore'],

  computed: {
    message() {
      switch (this.type) {
        case 'cardArchived':
          return this.translate('cardArchived');
        case 'cardArchivedByCard':
          return this.translate('cardArchivedByCard');
        case 'cardArchivedByList':
          return this.translate('cardArchivedByList');
        case 'cardArchivedByBoard':
          return this.translate('cardArchivedByBoard');
        case 'epicArchived':
          return this.translate('epicArchived');
        case 'epicArchivedByEpic':
          return this.translate('epicArchivedByEpic');
        case 'epicArchivedByList':
          return this.translate('epicArchivedByList');
        case 'boardArchived':
          return this.translate('boardArchived');
        case 'pageArchived':
          return this.translate('pageArchived');
        case 'cardArchivedBoard':
          return this.translate('cardPathArchivedBoard');
        case 'pageUsageLimit':
          return this.translate('pageUsageWarning');
        default:
          return '';
      }
    },
    shouldShowRestorationOption() {
      return (
        !['cardArchivedByList', 'cardArchivedByBoard'].includes(this.type) &&
        this.type !== 'pageUsageLimit'
      );
    },
  },

  methods: {
    restore() {
      this.$emit('restore');
    },
  },
};
</script>

<style lang="scss">
.mobile {
  .archived-bar {
    @apply min-h-[32px];
  }
}
</style>
